import { Button, Row } from 'antd';
import styled from 'styled-components';

export const TextTitle = styled.p`
  font-weight: bold;
  font-size: 32px;
  line-height: 37px;
  color: #001f2a;
  margin: 0;
  min-width: 370px;
  text-align: start;
`;
export const CSVButton = styled(Button)`
  background-color: #24a95d;
  border: none;
  width: 150px;
  height: 45px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: bold;
  margin-left: 90px;
  &:disabled {
    color: #ffffff;
    background-color: #E0E0E0;
  }
  &:hover {
    background-color: #24a95d;
    transform: scale(1.03);
  }
  &:focus {
    background-color: #24a95d;
  }
`;

export const Text = styled.p`
  font-weight: 500;
  font-size: 28px;
  line-height: 33px;
  color: #001F2A;
  margin: 0;
  width: 12em;
  text-align: start;
`;

export const BlocoRel = styled(Row)`
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  .anticon.anticon-calendar {
    color: #24a95d;
  }
  .ant-picker.ant-picker-range {
    background: #f2f2f2;
    border: none;
  }
  .ant-picker-input > input {
    color: #828282;
  }
  .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-start-single
    > div {
    border: 1px solid #24a95d;
    background: #24a95d;
  }
  .ant-picker-cell-in-view.ant-picker-cell-range-start::before {
    background: #24a95d;
  }
`;
